import { useRef, useEffect, forwardRef } from "react";
import { alpha, useTheme } from "@mui/material";
import {
  Box,
  IconButton,
  Typography,
  Autocomplete,
  TextField,
  Button,
  Tooltip,
  FormControlLabel,
  Switch,
  Menu,
  MenuItem,
  Loading,
} from "../../../components";
import { useState } from "react";
import {
  formatCnpjCpf,
  formatPrice,
  responseErros,
  timeoutBuscaAutocomplete,
} from "../../../utils";
import {
  ProdutosService,
  SessionService,
  notification,
  MeuUsuarioService,
  BalancaService,
} from "../../../services";
import store from "../../../config/store";
import { PermissoesHelper, value } from "../../../helpers";
import {
  montarItem,
  isProdutoFracionavel,
  normalizarQuantidade,
} from "../../../entities/pdv";
import ConfiguracoesTefDialog from "./dialog/configuracoes-tef-dialog.component";
import MenuAdministracaoTef from "./dialog/tef/administracao-tef-dialog.component";

export default function CabecalhoPdv({
  listaProdutos,
  setListaProdutos,
  dadosUsuario,
  dadosEmpresa,
  handleLogout,
  produto,
  setProduto,
  permitirVendaEstoqueNegativo,
  unidadeList,
  origensMercadoriasList,
  setItem,
  handleAdicionarProduto,
  setOpenImportarPedidoDialog,
  setOpenDialogHistoricoNfSaida,
  limparPdvAtalho,
  pdvOnLine,
  setPdvOnLine,
  buscarDadosIniciais,
  setListaProdutosSimilares,
  buscarProdutosOffLine,
  buscarProdutosByCodigoOffline,
  nfSaidasSincronizacaoPendentes,
  configuracoesTef,
  atualizarIniFileInfo,
  anchorEmpresas,
  setAnchorEmpresas,
  tefConnection,
  dadosMenuTef, 
  setDadosMenuTef,
  abrirDialogAdministracaoTef,
  openDialogAdministracaoTef,
  setOpenDialogAdministracaoTef,
  bloqueadoPorVendaEmAndamento,
}) {
  const [loadingAutoComplete, setLoadingAutoComplete] = useState(false);
  const [balancaErro, setBalancaErro] = useState(false);
  const [loading, setLoading] = useState(false);
  const [openDialogConfiguracaoTef, setOpenDialogConfiguracaoTef] =
    useState(false);
  const produtoService = new ProdutosService();
  const sessionService = new SessionService();
  const meuUsuarioService = new MeuUsuarioService();
  const balancaService = new BalancaService();
  const inputProdutoRef = useRef();
  const { configuracoes } = sessionService.getEmpresa();
  const dadosUsuarioAndEmpresa = sessionService.getEmpresaAndUsuario();
  const dadosOffline = sessionService.getDadosOffline();
  const empresa = dadosUsuarioAndEmpresa?.empresa || {};
  const empresasAcesso = dadosUsuarioAndEmpresa?.usuario?.acessosEmpresas || [];

  const permissoesHelper = new PermissoesHelper();

  const parseQuantidade = (value) => {
    if (!value) return null;
    const string = value.toString().replace(/\./g, "").replace(",", ".");
    const number = parseFloat(string);
    return isNaN(number) ? null : number;
  };

  const isCodigoBarras = (value) => {
    if (!value) return false;
    const valorNumerico = parseQuantidade(value);
    if (valorNumerico) {
      const tamanhoValor =
        valorNumerico.toString().length >= 7 &&
        valorNumerico.toString().length <= 13;
      return (
        Number.isFinite(valorNumerico) &&
        (configuracoes.buscaProdutosCodigoBarras || tamanhoValor)
      );
    } else return false;
  };

  const onInputChangeProdutos = (event) => {
    if (balancaErro) {
      setBalancaErro(false);
    }
    if (
      event.key === "Enter" &&
      inputProdutoRef.current === document.activeElement
    ) {
      let eventValue = event.target?.value;
      const isQuantidadeFind = eventValue.includes("*");
      if (isQuantidadeFind) {
        const value = eventValue.split("*");
        const quantidade = parseQuantidade(value[0]);
        const codigoProduto = value[1];
        if (quantidade === null || quantidade <= 0) {
          notification.alertaGenericos("Quantidade inválida");
          return;
        }
        const filtros = {
          codigo: codigoProduto,
          descricao: codigoProduto,
        };
        setLoadingAutoComplete(true);
        if (isCodigoBarras(codigoProduto, true)) {
          let codigoBarra = codigoProduto,
            valorProduto = null;
          if (
            configuracoes.inicialCodigoBarrasBalanca ===
              parseFloat(codigoProduto[0]) &&
            codigoProduto.length >= 7
          ) {
            if (codigoProduto.length >= 12) {
              valorProduto =
                parseInt(codigoProduto.slice(7, 12).replace(/^0+/, "")) / 100;
            }
            codigoBarra = codigoProduto.slice(0, 7);
          }
          buscarProdutosByCodigo(codigoBarra, quantidade, valorProduto);
        } else {
          timeoutBuscaAutocomplete(() => buscarProdutos(filtros));
        }
      } else {
        const filtros = {
          codigo: eventValue,
          descricao: eventValue,
          codigoBarra: eventValue,
        };
        setLoadingAutoComplete(true);
        if (isCodigoBarras(eventValue)) {
          let codigoBarra = eventValue,
            valorProduto = null,
            isBalancaPeso = false;
          if (
            configuracoes.inicialCodigoBarrasBalanca ===
              parseFloat(eventValue[0]) &&
            eventValue.length >= 7
          ) {
            if (eventValue.length >= 12) {
              valorProduto =
                parseInt(eventValue.slice(7, 12).replace(/^0+/, "")) / 100;
              if (configuracoes.leituraPadraoBalanca === "PESO") {
                isBalancaPeso = true;
                valorProduto =
                  parseInt(eventValue.slice(7, 12).replace(/^0+/, "")) / 1000;
              }
            }
            codigoBarra = eventValue.slice(0, 7);
          }
          buscarProdutosByCodigo(
            codigoBarra,
            null,
            valorProduto,
            isBalancaPeso,
          );
        } else {
          timeoutBuscaAutocomplete(() => buscarProdutos(filtros));
        }
      }
    }
  };

  const buscarProdutos = async (filtros, isProdutoSimilar = false) => {
    if (pdvOnLine) {
      await buscarProdutosOnline(filtros, isProdutoSimilar);
    } else {
      await buscarProdutosOffLine(
        filtros,
        setListaProdutos,
        setLoadingAutoComplete,
      );
    }
  };

  const buscarProdutosOnline = async (filtros, isProdutoSimilar) => {
    const filtro = {
      ...filtros,
      orderBy: "codigo",
      order: "asc",
      ativado: true,
      limite: 20,
    };
    produtoService.getAll(filtro).then((result) => {
      if (!result.isAxiosError) {
        setLoadingAutoComplete(false);
        if (isProdutoSimilar && result.data.rows?.length) {
          const itens = result.data.rows.map((item) => {
            const { informacao, ...rest } = item;
            const produtoResultante = { ...rest, ...informacao, id: rest.id };
            return montarItem(produto, produtoResultante, 1, false);
          });
          setListaProdutosSimilares(itens);
          return;
        }
        setListaProdutos(result.data.rows);
      } else {
        setLoadingAutoComplete(false);
        responseErros(result);
      }
    });
  };

  const buscarProdutosByCodigo = async (
    codigoBarra,
    quantidadeFind = null,
    valorProduto = null,
    isBalancaPeso = false,
  ) => {
    if (pdvOnLine) {
      await buscarProdutosByCodigoOnline(
        codigoBarra,
        quantidadeFind,
        valorProduto,
        isBalancaPeso,
      );
    } else {
      await buscarProdutosByCodigoOffline(
        codigoBarra,
        handleChangeAutocompleteProduto,
        setLoadingAutoComplete,
        quantidadeFind,
        valorProduto,
        isBalancaPeso,
      );
    }
  };

  const buscarProdutosByCodigoOnline = async (
    codigoBarra,
    quantidadeFind = null,
    valorProduto = null,
    isBalancaPeso = false,
  ) => {
    const result = await produtoService.getAllProdutosByCodigo({ codigoBarra });
    if (!result.isAxiosError) {
      setLoadingAutoComplete(false);
      if (result.data.length > 0) {
        let produto = result.data[0];
        let quantidade = quantidadeFind;
        let valor = valorProduto;
        if (valorProduto) {
          if (isBalancaPeso) {
            quantidade = valor;
            valor = valorProduto * produto.informacao.precoVenda;
          } else {
            quantidade = valorProduto / produto.informacao.precoVenda;
          }
        }
        handleChangeAutocompleteProduto(
          result.data[0],
          true,
          quantidade,
          valor,
        );
      } else {
        notification.alertaGenericos(
          `Nenhum produto encontrado com o código ${codigoBarra}`,
        );
      }
    } else {
      setLoadingAutoComplete(false);
      responseErros(result);
    }
  };

  function verificaEstoque(produto) {
    if (!permitirVendaEstoqueNegativo) {
      const estoque = produto?.estoqueProduto?.estoque;
      if (!estoque || estoque < 0) {
        notification.alertaGenericos("Produto fora de estoque");
        setProduto(null);
        return true;
      }
    }
    return false;
  }

  const isProdutoPesavel = (produtoAvaliado) =>
    produtoAvaliado?.lerPesoPorBalanca === "Ler peso da balança";

  const lerPesoBalanca = async () => {
    const result = await balancaService.lerPeso();
    if (result.isAxiosError || !result.data) {
      setBalancaErro(true);
      notification.alertaGenericos(
        "Não foi possível ler o peso da balança. Verifique a conexão.",
      );
      return null;
    }
    const { peso, estavel, status } = result.data;
    if (status === "PratoVazio" || !peso || peso <= 0) {
      setBalancaErro(true);
      notification.alertaGenericos(
        "Coloque o produto na balança para realizar a pesagem.",
      );
      return null;
    }
    if (!estavel) {
      setBalancaErro(true);
      notification.alertaGenericos(
        "Peso instável. Aguarde a balança estabilizar.",
      );
      return null;
    }
    setBalancaErro(false);
    return peso;
  };

  const handleChangeAutocompleteProduto = async (
    produtoEscolhido,
    isBuscaCodBar = false,
    quantidadeFind,
    valorProduto,
    isSimilar = false,
  ) => {
    document.getElementById("produtoId").blur();
    const { informacao, ...rest } = produtoEscolhido;
    const produtoResultante = { ...rest, ...informacao, id: rest.id };
    const estoque = verificaEstoque(produtoResultante);
    if (estoque) return;
    if (produtoEscolhido) {
      if (isProdutoPesavel(produtoResultante) && !quantidadeFind) {
        const peso = await lerPesoBalanca();
        if (!peso) return;
        quantidadeFind = peso;
        isBuscaCodBar = true;
      }
      let valorProdutoAplicado = valorProduto;
      if (
        quantidadeFind &&
        !isProdutoFracionavel(produtoResultante) &&
        !Number.isInteger(Number(quantidadeFind))
      ) {
        const quantidadeAjustada = normalizarQuantidade(
          produtoResultante,
          quantidadeFind,
        );
        notification.alertaGenericos(
          `${produtoResultante.descricao} não é fracionável. Quantidade ajustada de ${quantidadeFind} para ${quantidadeAjustada}.`,
        );
        quantidadeFind = quantidadeAjustada;
        valorProdutoAplicado = null;
      }
      const unidadeProduto = unidadeList.find(
        (unidade) => unidade.id == produtoResultante.unidadeComercialVendaId,
      );
      const tributosIcmsOrigem = origensMercadoriasList.find(
        (item) => item.id == produtoResultante.origemMercadoriaId,
      )?.codigo;
      const itemTemp = montarItem(
        produto,
        {
          ...produtoResultante,
          unidadeProduto,
          tributosIcmsOrigem,
        },
        quantidadeFind,
        true,
      );
      setProduto(produtoResultante);
      setItem(itemTemp);
      if (isBuscaCodBar) {
        handleAdicionarProduto(
          produtoResultante,
          itemTemp,
          valorProdutoAplicado,
        );
      } else if (produtoResultante.similares?.length) {
        const listaIdsProdutosSimilares = produtoResultante.similares.map(
          ({ similarId }) => similarId,
        );
        setLoadingAutoComplete(true);
        buscarProdutos({ id: listaIdsProdutosSimilares }, true);
      }
      // verificar fluxo abaixo para ver se esta usando userlog
      // const estoque = verificaEstoque(produtoResultante, isSimilar);
      // if (estoque && dadosUsuario?.acessosEmpresas?.length === 1) return;
      // userLogs(produtoResultante).then((logs) => {
      //   setUserLog(logs);
      // });
    } else {
      setProduto(null);
      setItem(null);
    }
  };

  // const handleAddActionsOpen = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  const handleAbrirMenuEmpresas = (event) => {
    setAnchorEmpresas(event.currentTarget);
  };

  const handleFecharMenuEmpresas = () => {
    setAnchorEmpresas(null);
  };

  const onChangePdvOnLine = async (event) => {
    setPdvOnLine(event.target.checked);
    sessionService.setPdvOnlineStatus(event.target.checked);
    if (event.target.checked) {
      nfSaidasSincronizacaoPendentes();
    }
    await buscarDadosIniciais(event.target.checked);
  };

  const ListBoxCustom = forwardRef((props, ref) => {
    const { children, ...other } = props;
    const theme = useTheme();
    const [indicatorStyle, setIndicatorStyle] = useState({
      top: 0,
      height: 0,
      opacity: 0,
    });
    const listRef = useRef(null);
    useEffect(() => {
      const updateIndicator = () => {
        if (!listRef.current) return;
        const focusedElement = listRef.current.querySelector(".Mui-focused");

        if (focusedElement) {
          setIndicatorStyle({
            top: focusedElement.offsetTop,
            height: focusedElement.offsetHeight,
            opacity: 1,
          });
        } else {
          setIndicatorStyle((prev) => ({ ...prev, opacity: 0 }));
        }
      };
      const observer = new MutationObserver(updateIndicator);
      if (listRef.current) {
        observer.observe(listRef.current, {
          attributes: true,
          subtree: true,
          attributeFilter: ["class"],
        });
      }
      return () => observer.disconnect();
    }, []);

    return (
      <div ref={ref} {...other}>
        <ul
          ref={listRef}
          style={{ position: "relative", padding: 0, marginInline: 9 }}
        >
          <div
            style={{
              borderRadius: 8,
              position: "absolute",
              left: 0,
              width: "100%",
              backgroundColor: alpha(theme.palette.primary.main, 0.1),
              transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
              pointerEvents: "none",
              zIndex: 0,
              ...indicatorStyle,
            }}
          />
          {children}
        </ul>
      </div>
    );
  });

  const trocarEmpresa = async (empresaId) => {
    if (
      empresa.id != empresaId &&
      !bloqueadoPorVendaEmAndamento("trocar de empresa")
    ) {
      setLoading(true);
      const response = await meuUsuarioService.trocarToken(empresaId);
      setLoading(false);
      if (!response.isAxiosError) {
        sessionService.setEmpresa(response.data.dados.empresa);
        sessionService.setToken(response.data.token);
        window.location.reload();
      } else {
        responseErros(response);
      }
    }
    handleFecharMenuEmpresas();
  };

  const onClickImportarPedido = () => {
    if (bloqueadoPorVendaEmAndamento("importar pedido")) return;
    if (pdvOnLine) {
      setOpenImportarPedidoDialog(true);
    } else {
      notification.alertaGenericos(
        "Funcionalidade disponível apenas no modo online.",
      );
    }
  };

  const abrirDialogConfiguracaoTef = () => {
    handleFecharMenuEmpresas();
    setOpenDialogConfiguracaoTef(true);
  };

  return (
    <Box
      className={`cabecalho-pdv ${!pdvOnLine ? "cabecalho-pdv-offline" : ""}`}
    >
      <div>
        <Typography variant="h5" sx={{ fontWeight: 800 }} className="d-flex">
          SIAF
          <span style={{ fontWeight: 500, fontSize: "12px" }}>EVOLUTION</span>
          PDV
          <span className="fw-light ps-1" style={{ fontSize: "12px" }}>
            {store.version}
          </span>
        </Typography>
        <span className="fw-light" style={{ fontSize: "12px" }}>
          {dadosOffline?.nomePdvOffline || ""}
        </span>
      </div>
      <div className="w-100 d-flex align-items-center justify-content-between gap-4">
        <Autocomplete
          ListboxComponent={ListBoxCustom}
          id="produtoId"
          name="produtoId"
          className="mousetrap"
          options={listaProdutos}
          autoHighlight
          loading={loadingAutoComplete}
          loadingText="Carregando"
          noOptionsText="Digite e pressione Enter"
          renderOption={(props, option) => {
            let descricaoProduto = `${option?.codigo} - ${option?.descricao}`;
            return option ? (
              <li {...props} style={{ background: "transparent" }}>
                <div className="d-flex justify-content-between align-items-center w-100">
                  <div>
                    <span className="fw-bold">{descricaoProduto}</span>
                    <div className="d-flex gap-3">
                      <Typography variant="body2">
                        Unidade:{" "}
                        {
                          value.autoComplete(
                            unidadeList || [],
                            option?.unidadeComercialVendaId,
                          ).codigo
                        }
                      </Typography>
                      <Typography variant="body2">
                        Cód.barra: {option?.codigoBarra}
                      </Typography>
                    </div>
                    <Typography variant="body2" className="fw-bolder">
                      Estoque disponível:{" "}
                      <span
                        className={
                          option?.estoqueProduto?.estoque < 0
                            ? "text-danger"
                            : "text-success"
                        }
                      >
                        {option?.estoqueProduto?.estoque}
                      </span>
                    </Typography>
                  </div>
                  <div className="text-end">
                    <Typography variant="body2">Preço venda</Typography>
                    <span className="fs-6">
                      {formatPrice(option?.informacao?.precoVenda || 0)}
                    </span>
                  </div>
                </div>
              </li>
            ) : (
              ""
            );
          }}
          getOptionLabel={(option) => {
            let descricaoProduto = `${option?.codigo} - ${option?.descricao}`;
            return option ? descricaoProduto : "";
          }}
          filterSelectedOptions
          onChange={(_, newValue) => handleChangeAutocompleteProduto(newValue)}
          value={produto}
          renderInput={(params) => (
            <TextField
              {...params}
              variant={"outlined"}
              className="mousetrap"
              error={balancaErro}
              placeholder="Pesquise produtos pela descrição"
              onKeyDown={(e) => onInputChangeProdutos(e)}
              inputRef={inputProdutoRef}
              InputProps={{
                ...params.InputProps,
              }}
            />
          )}
        />
        <Tooltip title="Histórico NF Saída" arrow placement="bottom">
          <Button
            variant="outlined"
            color="padrao"
            onClick={() => setOpenDialogHistoricoNfSaida(true)}
            sx={{
              p: "1rem 2rem",
              fontSize: 20,
              boxShadow: "none",
              fontWeight: 700,
              height: "54px",
              width: "54px",
            }}
          >
            <i className="ph-fill ph-folder-open"></i>
          </Button>
        </Tooltip>
        <Button
          onClick={onClickImportarPedido}
          variant="outlined"
          color="padrao"
          sx={{
            p: "1rem 2rem",
            ml: "0.5em",
            color: "#494c62",
            fontSize: 12,
            fontWeight: 700,
          }}
        >
          Importar
        </Button>
        <Tooltip title="Limpar Carrinho" arrow placement="bottom">
          <Button
            id="limparPdv"
            variant="outlined"
            color="padrao"
            onClick={limparPdvAtalho}
            sx={{
              p: "1rem 2rem",
              fontSize: 20,
              boxShadow: "none",
              fontWeight: 700,
              height: "54px",
              width: "54px",
            }}
          >
            <i
              className="ph-fill ph-paint-brush-broad"
              style={{ transform: "rotate(180deg)" }}
            ></i>
          </Button>
        </Tooltip>
        {dadosEmpresa.modoOfflinePdv && (
          <FormControlLabel
            control={
              <Switch
                checked={pdvOnLine}
                onChange={onChangePdvOnLine}
                inputProps={{ "aria-label": "controlled" }}
                name="pdvOnLine"
                size="small"
                color="primary"
              />
            }
            label={
              <Typography variant="body2" className="px-1">
                {pdvOnLine ? "Online" : "Offline"}
              </Typography>
            }
          />
        )}
      </div>
      <div className="d-flex align-items-center justify-content-end gap-4">
        <div className="d-flex-max align-items-center">
          <i
            className="ph-fill ph-user-circle"
            style={{ fontSize: 17, marginRight: 10 }}
          ></i>
          <Typography variant="body2">
            {dadosUsuario ? dadosUsuario.nome : ""}
          </Typography>
        </div>
        {/*<Button onClick={() => setOpenDialogOperacoesCaixa(true)}>
          <div className="d-flex-max">
            <i
              className="ph-fill ph-shopping-bag-open"
              style={{ fontSize: 20, marginRight: 10 }}
            ></i>
            <Typography>
              Caixa
            </Typography>
          </div>
        </Button>*/}
        {/* <IconButton
          aria-label="add action caixa"
          aria-controls={menuId}
          aria-haspopup="true"
          aria-expanded={isMenuOpen ? "true" : undefined}
          onClick={handleAddActionsOpen}
          style={{
            backgroundColor: "#E5E5E5",
          }}
        >
          <i
            className="ph-bold ph-dots-three-vertical"
            style={{ fontSize: 23 }}
          ></i>
        </IconButton> */}
        {empresa && (
          <div>
            <IconButton
              className="me-1"
              style={{
                padding: 10,
                borderRadius: 12,
                boxShadow: "0px 0px 56px rgba(0, 0, 0, 0.08)",
              }}
              color="inherit"
            >
              <i
                className="ph-fill ph-buildings"
                style={{ fontSize: "clamp(17px, 4vw, 25px)" }}
              ></i>
              {empresa.fantasia?.length <= 40 ? (
                <div className="d-flex gap-3">
                  <div className="d-flex flex-column text-start mx-2">
                    <Typography
                      style={{
                        color: `${"#494C62"}`,
                        textTransform: "uppercase",
                        whiteSpace: "nowrap",
                      }}
                      variant="caption"
                    >
                      {empresa.fantasia.length > 20
                        ? empresa.fantasia.slice(0, 20) + "..."
                        : empresa.fantasia}
                    </Typography>
                    <Typography
                      style={{
                        color: "#494C62",
                        textTransform: "uppercase",
                        whiteSpace: "nowrap",
                      }}
                      variant="caption"
                    >
                      {formatCnpjCpf(empresa.cnpjCpf)}
                    </Typography>
                  </div>
                  <IconButton
                    onClick={(e) => {
                      e.stopPropagation();
                      handleAbrirMenuEmpresas(e);
                    }}
                    color="inherit"
                    style={{ borderRadius: 8 }}
                    sx={{
                      backgroundColor: "#EDEEF0",
                      "&:hover": { backgroundColor: "#B6BABC" },
                    }}
                  >
                    <i
                      className="ph-bold ph-caret-down"
                      style={{ fontSize: "clamp(8px, 4vw, 15px)" }}
                    ></i>
                  </IconButton>
                </div>
              ) : null}
            </IconButton>
            <Menu
              anchorEl={anchorEmpresas}
              open={Boolean(anchorEmpresas)}
              onClose={handleFecharMenuEmpresas}
              anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
              transformOrigin={{ vertical: -10, horizontal: "right" }}
              PaperProps={{
                style: {
                  maxHeight: 300,
                  width: "35ch",
                  borderRadius: "12px",
                  boxShadow: "0px 4px 20px rgba(0, 0, 0, 0.1)",
                },
              }}
            >
              {empresasAcesso
                .filter((empresaAcesso) => empresaAcesso.id != empresa.id)
                .map((empresa) => (
                  <MenuItem
                    key={empresa.id}
                    onClick={() => trocarEmpresa(empresa.id)}
                    selected={empresa.id === empresa.id}
                    sx={{
                      "&.Mui-selected": {
                        backgroundColor: "#f5f5f5",
                        "&:hover": { backgroundColor: "#e0e0e0" },
                      },
                    }}
                  >
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <Typography variant="body2" noWrap>
                        {empresa.fantasia || empresa.razaoSocial}
                      </Typography>
                      <Typography variant="caption" color="textSecondary">
                        {formatCnpjCpf(empresa.cnpjCpf)}
                      </Typography>
                    </div>
                  </MenuItem>
                ))}
              {empresa?.moduloTef &&
                permissoesHelper.temPermisao("configuracao-tef") && (
                  <MenuItem onClick={abrirDialogConfiguracaoTef}>
                    <Typography
                      variant="body2"
                      sx={{ flexGrow: 1, color: "#000000" }}
                    >
                      Configurações TEF
                    </Typography>
                    <i
                      className="ph-bold ph-gear-six"
                      style={{ fontSize: 19, color: "#000000", marginLeft: 10 }}
                    ></i>
                  </MenuItem>
                )}
              {empresa?.moduloTef && (
                <MenuItem onClick={() => abrirDialogAdministracaoTef()}>
                  <Typography
                    variant="body2"
                    sx={{ flexGrow: 1, color: "#000000" }}
                  >
                    Administração TEF
                  </Typography>
                  <i
                    className="ph-bold ph-bank"
                    style={{ fontSize: 19, color: "#000000", marginLeft: 10 }}
                  ></i>
                </MenuItem>
              )}
              <MenuItem
                onClick={() => {
                  handleLogout();
                }}
              >
                <Typography
                  variant="body2"
                  sx={{ flexGrow: 1, color: "#e44a42" }}
                >
                  SAIR
                </Typography>
                <i
                  className="ph-bold ph-sign-out"
                  style={{ fontSize: 19, color: "#e44a42", marginLeft: 10 }}
                ></i>
              </MenuItem>
            </Menu>
          </div>
        )}
      </div>
      <ConfiguracoesTefDialog
        open={openDialogConfiguracaoTef}
        setOpen={setOpenDialogConfiguracaoTef}
        configuracoesTef={configuracoesTef}
        atualizarIniFileInfo={atualizarIniFileInfo}
      />
      <MenuAdministracaoTef
        open={openDialogAdministracaoTef}
        setOpen={setOpenDialogAdministracaoTef}
        dadosMenuTef={dadosMenuTef}
        setDadosMenuTef={setDadosMenuTef}
        tefConnection={tefConnection}
        setLoading={setLoading}
      />
      <Loading loading={loading} />
    </Box>
  );
}
